import { useCallback } from 'react';

import { StepEnum } from '@enum/step.enum';
import { useUserMeta } from '@hook/user/use-user-meta.hook';

export const useStep = () => {
  const {
    meta: { step = StepEnum.None },
    onSaveMeta,
    isLoaded,
    isLoading,
  } = useUserMeta();

  const onChange = useCallback(
    (current: StepEnum) => step < current && onSaveMeta({ step: current }),
    [step, onSaveMeta],
  );

  return {
    step,
    onChange,
    isLoaded,
    isLoading,
  };
};
